//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { settingsGUI } from '../../pages/main/sections/UserSettings/UserSettingsGUI.js'
import { mask } from 'vue-the-mask'
import { inputMaskProcessor } from './InputMaskProcessor.js'

// Московская обл.:
const LON_MIN = 35.9
const LON_MAX = 39.7
const LAT_MIN = 54.5
const LAT_MAX = 57

export default {
  name: 'GeoPointField',
  directives: { mask },
  mixins: [settingsGUI, inputMaskProcessor],
  props: {
    value: {
      type: [Object, Array],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editorTile: {
      type: String,
      default: 'Координаты'
    }
  },
  data: () => {
    return {
      placeholderSymbol: '',
      editorValue: '',
      previousEditorValue: '',
      backspace: false,
      paste: false,
      lastSelection: {
        start: 0,
        end: 0
      },
      tokens: {
        number: {
          pattern: /\d+.\d+/
        }
      }
    }
  },
  computed: {
    coordinateOrderLonLat: function () {
      return this.$store.getters.getUserSetting('ui.common.coordinateOrder', 'lonlat') === 'lonlat'
    },
    coordsRaw: function () {
      if (this.value) {
        return [[this.value.lon, this.value.lat]] // TODO
      }
      return null
    },
    coordsText: function () {
      if (this.coordsRaw && this.coordsRaw.length) {
        return this.formatCoords(this.coordsRaw[0])
      }
      return null
    },
    valid: function () {
      return this.validateLocation(this.editorValue, LON_MIN, LON_MAX, LAT_MIN, LAT_MAX)
    }
  },
  watch: {
    value: function (val) {
      console.log('update')
      console.log(val)
      this.editorValue = this.coordsText
    }
  },
  mounted: function () {
    this.editorValue = this.coordsText
    this.applyInputMaskProcessor('field', '##.######, ##.######')
    Vue.nextTick(() => {
      this.$refs.field.resetValidation()
    })
  },
  methods: {
    coordinateToNumber: function (value) {
      return value && value.length ? Number(value) : null
    },
    coordinateToString: function (value) {
      return value ? value.toFixed(6) : null
    },
    onClear: function (value) {
      Vue.nextTick(() => {
        this.placeholderSymbol = ''
        this.editorValue = ''
        this.$refs.field.resetValidation()
      })
      this.$refs.field.blur()
    },
    onBlur: function () {
      this.placeholderSymbol = ''
      Vue.nextTick(() => {
        if (this.editorValue === '00.000000, 00.000000') {
          this.editorValue = ''
        }
      })
    },
    rules: function (value) {
      return this.ruleLocation(value, LON_MIN, LON_MAX, LAT_MIN, LAT_MAX)
    },
    ruleLocation: function (value, lonMin, lonMax, latMin, latMax) {
      const coordinates = value && value.split(', ') || []
      if (coordinates.length < 2) {
        if (coordinates[0] == '' && this.clearable) {
          return true
        }
        return 'Введите обе координаты через запятую'
      }
      if ((coordinates[0].length < 9) != (coordinates[1].length < 9)) {
        return 'Необходимо ввести 6 знаков после запятой'
      }
      let lon = this.coordinateToNumber(coordinates[1])
      let lat = this.coordinateToNumber(coordinates[0])
      if (this.coordinateOrderLonLat) {
        lon = this.coordinateToNumber(coordinates[0])
        lat = this.coordinateToNumber(coordinates[1])
      }
      if (lonMin > lon || lon > lonMax || latMin > lat || lat > latMax) {
        return 'За пределами допустимого региона'
      }
    },
    valueEmpty: function (value) {
      const placeholder = this.placeholderSymbol === '' ? '_' : this.placeholderSymbol
      return value === placeholder.repeat(2) + '.' + placeholder.repeat(6) + ', ' + placeholder.repeat(2) + '.' + placeholder.repeat(6)
    },
    validateLocation: function (value, lonMin, lonMax, latMin, latMax) {
      if (value && !this.valueEmpty(value)) {
        const coordinates = value.split(', ')
        if (coordinates.length < 2) {
          if (coordinates[0] == '' && this.clearable) {
            return true
          } else if (coordinates[0].length > 3 && coordinates[0].length < 9) {
            return 'Введите шесть знаков после запятой'
          }
          return 'Введите обе координаты через запятую'
        }
        if (coordinates[1].length > 3 && coordinates[1].length < 9) {
          return 'Введите шесть знаков после запятой'
        }
        const { lon, lat } = this.parseCoordinatesValueFromStringsArray(coordinates)
        if (lonMin > lon || lon > lonMax || latMin > lat || lat > latMax) {
          return false
        }
      } else if (this.valueEmpty(value) && !this.clearable) {
        return 'Обязательное значение'
      }
      return true
    },
    prepareInputValue: function (value) {
      let newValue = value
      const coords = newValue.split(', ')
      coords.forEach((element, index) => {
        element = element.replace(/[^\d]/g, '')
        element = element.slice(0, 2) + '.' + element.slice(2)
        if (element.length > 9) {
          // console.log(coords[index])
          element = element.slice(0, 9)
          coords[index] = element
          this.$q.notify({
            type: 'warning',
            message: 'Значение скорректировано (уменьшена точность)',
            progress: true,
            timeout: 3000
          })
        } else {
          if (element.length > 2 && element.length < 9) {
            while (element.length < 9) {
              element = element + '0'
            }
            coords[index] = element
            this.$q.notify({
              type: 'warning',
              message: 'Значение скорректировано (добавлены нули)',
              progress: true,
              timeout: 3000
            })
          } else if (element.length <= 2) {
            while (element.length < 2) {
              element = element + '0'
            }
            element = element + '.'
            while (element.length < 9) {
              element = element + '0'
            }
            coords[index] = element
            this.$q.notify({
              type: 'warning',
              message: 'Значение скорректировано (добавлены нули)',
              progress: true,
              timeout: 3000
            })
          }
        }
      })
      newValue = coords.join(', ')
      this.commaIndex = newValue.indexOf(',') == -1 ? null : newValue.indexOf(',')
      return newValue
    },
    freePositionsCount: function (value) {
      let count = 0
      for (let i = value.length - 1; i >= 0; i--) {
        if (value[i] === this.placeholderSymbol) {
          count++
        } else if (value[i] !== '.' && value[i] !== ',' && value[i] !== ' ') {
          break
        }
      }
      return count
    },
    moveNumbers: function (str, diff) {
      let newStr = str
      for (let i = newStr.length - 1; i > -1 + diff; i--) {
        if (newStr[i - diff] !== '.' && newStr[i - diff] !== ',' && newStr[i - diff] !== ' ') {
          let newPosition = i
          while (newStr[newPosition] === '.' || newStr[newPosition] === ',' || newStr[newPosition] === ' ') {
            newPosition++
          }
          newStr = newStr.slice(0, newPosition) + newStr[i - diff] + newStr.slice(newPosition + 1, newStr.length)
        }
      }
      for (let i = 0; i < diff; i++) {
        newStr = newStr.slice(0, i) + this.placeholderSymbol + newStr.slice(i + 1, newStr.length)
      }
      return newStr
    },
    prepareBackspaceValue: function (value, previousValue) {
      let newValue = value
      const cursorPosition = this.$refs.field.$refs.input.prevCursorPosition
      const previousFreePositionsCount = this.freePositionsCount(previousValue)
      const currentFreePositionsCount = this.freePositionsCount(value)
      const deletedAmount = currentFreePositionsCount - previousFreePositionsCount
      newValue = newValue.slice(0, cursorPosition) + this.moveNumbers(newValue.slice(cursorPosition, newValue.length), deletedAmount)
      return newValue
    },
    trimValue: function (value) {
      let end = value.length - 1
      while (value[end] === '0') {
        end--
      }
      end++
      return value.slice(0, end)
    },
    onKeyDown: function (event) {
      this.backspace = event.key === 'Backspace' || event.key === 'Delete'
      this.paste = event.code === 'KeyV' && event.ctrlKey
    },
    onInput: function (value) {
      Vue.nextTick(() => {
        if (this.backspace) {
          this.editorValue = this.prepareBackspaceValue(value, this.previousEditorValue)
        }
        if (this.paste) {
          navigator.clipboard.readText().then(text => {
            let newValue = this.prepareInputValue(text)
            if (this.lastSelection.end - this.lastSelection.start <= 1 || this.lastSelection.end - this.lastSelection.start === 20) {
              this.editorValue = newValue
            } else {
              newValue = this.trimValue(newValue).replace(/[^\d., ]/)
              const range = this.lastSelection.end - this.lastSelection.start
              this.editorValue = this.editorValue.slice(0, this.lastSelection.start) + newValue + this.editorValue.slice(this.lastSelection.start + (newValue.length > range ? newValue.length : range), this.editorValue.length)
            }
          })
        }
        this.previousEditorValue = this.editorValue
        this.backspace = false
        this.paste = false
      })
    },
    onClick: function (event) {
      this.lastSelection.start = event.target.selectionStart
      this.lastSelection.end = event.target.selectionEnd
    },
    onChange: function () {
      this.emitValue()
    },
    emitValue: function () {
      if (this.valid) {
        let value = null
        if (this.editorValue) {
          value = this.parseCoordinatesValueFromString(this.editorValue)
        }
        this.$emit('input', value)
      }
    },
    parseCoordinatesValueFromString: function (value) {
      const coordinates = value.split(', ')
      return this.parseCoordinatesValueFromStringsArray(coordinates)
    },
    /**
     * @param coordinates [String, String]
     * @return {{lon: Number, lat: Number}}
     */
    parseCoordinatesValueFromStringsArray: function (coordinates) {
      let lon = this.coordinateToNumber(coordinates[1])
      let lat = this.coordinateToNumber(coordinates[0])
      if (this.coordinateOrderLonLat) {
        lon = this.coordinateToNumber(coordinates[0])
        lat = this.coordinateToNumber(coordinates[1])
      }
      return { lon: lon, lat: lat }
    },
    /**
     * @param coordinates [Number, Number]
     * @return {{lon: Number, lat: Number}}
     */
    parseCoordinatesValueFromNumbersArray: function (coordinates) {
      const lat = this.coordinateToString(coordinates[0])
      const lon = this.coordinateToString(coordinates[1])
      return { lon: lon, lat: lat }
    }
  }
}
